import create from "zustand";

const useStore = create((set, get) => ({
    open: null,
    setOpen: (open) => set({ open }),
    close: () => get().setOpen(null),
}));

export default useStore;
